<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-19 15:07:17
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-31 16:50:56
 * @FilePath: /wemeet-admin-new/src/views/recruitment/recommend/RecommenderChannel.vue
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
-->
<template>
  <div class="recommender-channel">
    <el-form inline @submit.prevent="query(1)">
      <el-form-item label="推荐人姓名">
        <el-input v-model="queryParams.name" clearable placeholder="请输入推荐人姓名" @change="query(1)" />
      </el-form-item>
      <el-form-item label="推荐人手机号">
        <el-input v-model="queryParams.phone" clearable placeholder="请输入推荐人手机号" @change="query(1)" />
      </el-form-item>
      <el-form-item label="推荐人状态">
        <el-select v-model="queryParams.status" clearable placeholder="请选择岗位状态" @change="query(1)">
          <el-option
            v-for="item in recommenderStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="search" type="primary" @click="query()">查询</el-button>
        <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
        <el-button icon="download" type="primary" @click="downloadExcel()">导出报表</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" border :data="tableData" :table-layout="'auto'">
      <el-table-column label="推荐人姓名" prop="name" />
      <el-table-column label="推荐人手机号" prop="phone" />
      <el-table-column label="推荐人状态" prop="status">
        <template #default="{ row }">
          <el-link :type="row.status === RECOMMENDER_STATUS.IN_USE ? 'success' : 'info'" :underline="false">
            {{ RECOMMENDER_STATUS_CN[row.status] }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="推荐总人数" prop="totalCount" />
      <el-table-column label="已入职" prop="alreadyEmployedTotalCount" />
      <el-table-column label="投递未反馈" prop="deliveryTotalCount" />
      <el-table-column label="离职" prop="departureTotalCount" />
      <el-table-column label="可提现奖金" prop="rewardAmount" />
      <el-table-column label="操作">
        <template #default="{ row }">
          <el-link type="primary" :underline="false" @click="changeStatus(row)">更改状态</el-link>
          <el-link type="primary" :underline="false" @click="showDetail(row)">查看详情</el-link>
          <el-link type="primary" :underline="false" @click="downloadExcelByRow(row)">下载报表</el-link>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-model:current-page="queryParams.pageNum"
      background
      layout="prev, pager, next"
      :page-size="queryParams.pageSize"
      :total="queryParams.total"
      @current-change="query"
    />

    <!-- 推荐人详情 -->
    <RecommenderDetail
      :recommend-code="detailModal.recommendCode"
      :visible="detailModal.visible"
      @close="handleDetailClose"
    />

    <!-- 导出 -->
    <ExportDrawer
      :data="exportDrawerData"
      title="推荐人渠道报表导出"
      :visible="exportDrawerVisible"
      @close="closeExportDrawer"
      @refresh="refreshExcel"
    />

    <!-- 更改状态 -->
    <el-dialog v-model="statusModal.visible" destroy-on-close title="更改状态" :width="400" @close="closeStatusModal">
      <el-radio-group v-if="statusModal.data" v-model="statusModal.data.status">
        <el-radio v-for="item in recommenderStatusOptions" :key="item.value" :label="item.value">
          {{ item.label }}
        </el-radio>
      </el-radio-group>
      <template #footer>
        <el-button @click="closeStatusModal">取消</el-button>
        <el-button type="primary" @click="confirmStatus">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
  import { omit, pick } from 'lodash'
  import { getRecommenderList, changeRecommendStatus } from '@/api/recruitment'
  import { RECOMMENDER_STATUS, RECOMMENDER_STATUS_CN, exportType } from '../context'
  import RecommenderDetail from './RecommenderDetail.vue'
  import { useExportDrawer } from '@/hooks/useExportDrawer'
  import ExportDrawer from '@/components/ExportDrawer.vue'

  const { proxy } = getCurrentInstance()

  const recommenderStatusOptions = Object.values(RECOMMENDER_STATUS).map((v) => ({
    value: v,
    label: RECOMMENDER_STATUS_CN[v],
  }))

  const defaultQueryParams = {
    name: '',
    phone: '',
    status: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const loading = ref(false)
  const tableData = ref([])

  function query(pageNum = queryParams.pageNum) {
    const params = {
      ...omit(queryParams, 'total'),
      pageNum,
    }

    loading.value = true

    getRecommenderList(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { list, total } = data
        tableData.value = list
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query(1)
  }

  onMounted(() => {
    query()
  })

  const detailModal = reactive({
    visible: false,
    data: null,
  })

  function showDetail(row) {
    detailModal.recommendCode = row.recommendCode
    detailModal.visible = true
  }

  function handleDetailClose() {
    detailModal.visible = false
    detailModal.recommendCode = ''
  }

  const statusModal = reactive({
    visible: false,
    data: null,
  })

  function changeStatus(row) {
    statusModal.data = { ...row }
    statusModal.visible = true
  }

  function closeStatusModal() {
    statusModal.visible = false
    statusModal.data = null
  }

  function confirmStatus() {
    changeRecommendStatus(pick(statusModal.data, 'recommendCode', 'status')).then(({ code }) => {
      if (code !== 200) return
      closeStatusModal()
      proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
      query()
    })
  }

  const {
    visible: exportDrawerVisible,
    data: exportDrawerData,
    generateExcel,
    refreshExcel,
    close: closeExportDrawer,
  } = useExportDrawer()

  function downloadExcel() {
    const type = exportType.RECOMMENDER_ALL
    const params = {
      type,
      relationType: type,
      condition: omit(queryParams, 'pageNum', 'pageSize', 'total'),
    }
    generateExcel(params)
  }

  function downloadExcelByRow(row) {
    const type = exportType.RECOMMENDER_CHANNEL
    const params = {
      relationCode: row.recommendCode,
      type,
      relationType: type,
      condition: {}, // 后端需要一个空对象
    }
    generateExcel(params)
  }
</script>

<style lang="scss" scoped>
  .recommender-channel {
    padding: 16px;
  }
</style>
